// extracted by mini-css-extract-plugin
export default {"container_inputs":"styles_container_inputs__uWqa7","buttons":"styles_buttons__IylRc","buttons_actions":"styles_buttons_actions__wq1OH"};